export var ParameterStep;
(function (ParameterStep) {
    ParameterStep[ParameterStep["GLOBAL_SETTINGS"] = 1] = "GLOBAL_SETTINGS";
    ParameterStep[ParameterStep["BENEFICIARY_VALUES"] = 2] = "BENEFICIARY_VALUES";
    ParameterStep[ParameterStep["FEEDBACK"] = 3] = "FEEDBACK";
})(ParameterStep || (ParameterStep = {}));
